/* Sondos hero — peek carousel (sections/sondos-hero-peek.liquid).
   DOM: [2 tail clones][n real slides][2 head clones], flex row in an RTL section, so slide 0 sits right of slide 1
   and the next campaign enters from the left. Position p indexes the full list; real slide i lives at p = i + 2.
   Every move is a translate of the track; after a move into a clone the track jumps (no transition) to the twin. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__shp) return; root.__shp = true;
    var viewport = root.querySelector('.shp__viewport');
    var track = root.querySelector('.shp__track');
    var all = Array.prototype.slice.call(track.children);
    var real = all.filter(function (s) { return !s.hasAttribute('data-clone'); });
    var n = real.length;
    if (n < 2) { root.classList.add('sk-hero--ready'); return; }
    var dots = Array.prototype.slice.call(root.querySelectorAll('.shp__dot'));
    var pauseBtn = root.querySelector('.shp__pause');
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var p = 2, x = 0, busy = false;
    var userPaused = root.getAttribute('data-autoplay') !== 'true' || reduce;
    var held = { hover: false, focus: false, hidden: false, offscreen: false, drag: false, boot: true, sheet: false, touch: false };

    /* ── ready gate (same contract as the previous hero) ── */
    var ready = false;
    function markReady() { if (ready) return; ready = true; root.classList.add('sk-hero--ready'); warm(); bootDone(); }
    /* Images: the first card is the LCP (preloaded, high). The peeks and the next/previous two used to wait for the
       whole page (window load) and then for native lazy-loading to notice them — on a slow line a card could slide in
       empty. Now: ±2 around the active card switch to eager as soon as the first image is in, and again on every move —
       with a 3s cycle the next card always has a full cycle to arrive. Nothing further is fetched ahead (a visitor who
       never swipes does not pay for 11 images). A blurred inline preview was tried and removed the same day: on iPhone
       Safari the filter layer re-rasterised the whole card late during each slide (blur, copy missing) — owner's video. */
    function warm(all_) {
      if (!ready) return;
      var c = realIndex(p);
      Array.prototype.forEach.call(track.querySelectorAll('.shp__img'), function (im) {
        var i = +im.closest('.shp__slide').getAttribute('data-i');
        var d = Math.abs(i - c); d = Math.min(d, n - d);
        if ((all_ || d <= 2) && im.loading !== 'eager') {
          // the two peeks are ON SCREEN: once the LCP is in they outrank the app scripts still downloading
          if (d === 1 && 'fetchPriority' in im) im.fetchPriority = 'high';
          im.loading = 'eager';
        }
      });
    }
    /* autoplay never starts before the first campaign image (the LCP) has painted and the page is ready */
    var lcp = root.querySelector('.sk-hero__slide.is-active .sk-hero__img');
    function bootDone() { if (!ready || (lcp && !lcp.complete)) return; if (held.boot) { held.boot = false; if (typeof syncState === 'function') syncState(); } }
    if (lcp && !lcp.complete) { lcp.addEventListener('load', function () { markReady(); bootDone(); }, { once: true }); lcp.addEventListener('error', function () { lcp = null; bootDone(); }, { once: true }); }
    if ((window.Shopify && window.Shopify.designMode) || document.readyState === 'complete' || (lcp && lcp.complete && lcp.naturalWidth)) markReady();
    else {
      window.addEventListener('load', markReady, { once: true });
      setTimeout(markReady, Math.max(2500, speed - 1500));
      ['pointerdown', 'touchstart', 'keydown', 'focusin'].forEach(function (e) { root.addEventListener(e, markReady, { once: true, passive: true }); });
    }

    /* ── geometry ── */
    function offsetFor(pos) {
      var s = all[pos];
      return viewport.clientWidth / 2 - (s.offsetLeft + s.offsetWidth / 2);
    }
    function place(pos, animate) {
      x = offsetFor(pos);
      track.classList.toggle('is-anim', !!animate && !reduce);
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    function realIndex(pos) { return ((pos - 2) % n + n) % n; }

    function setActive() {
      var i = realIndex(p);
      real.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        var a = s.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); d.classList.toggle('is-past', k < i); });
      warm();
      restartFill();
    }

    /* where the track really is on screen right now (mid-transition included) */
    function visualX() {
      var m = getComputedStyle(track).transform;
      if (!m || m === 'none') return x;
      var v = m.match(/matrix(?:3d)?\(([^)]+)\)/); if (!v) return x;
      var a = v[1].split(',');
      return parseFloat(a.length === 16 ? a[12] : a[4]) || 0;
    }
    function nearest(px) {
      var best = p, d = Infinity;
      for (var k = 0; k < all.length; k++) { var dd = Math.abs(offsetFor(k) - px); if (dd < d) { d = dd; best = k; } }
      return best;
    }
    function setX(px) { x = px; track.style.transform = 'translate3d(' + px + 'px,0,0)'; }
    /* jump to the real twin of a clone with no visible change (both sit at the same place relative to the viewport) */
    function fold() {
      var twin = p < 2 ? p + n : (p >= n + 2 ? p - n : p);
      if (twin !== p) { var shift = offsetFor(twin) - offsetFor(p); p = twin; setX(x + shift); }
    }
    /* stop a running move exactly where it is: freeze, adopt the nearest slot, fold out of the clones */
    var guard = 0;
    function settle() {
      clearTimeout(guard);
      if (!busy) return;
      var vx = visualX();
      track.classList.remove('is-anim');
      setX(vx);
      p = nearest(vx);
      busy = false;
      fold();
    }
    function go(pos) {
      if (busy) settle();
      markReady();
      p = Math.max(0, Math.min(all.length - 1, pos));
      busy = !reduce;
      place(p, true);
      setActive();
      if (reduce) normalise();
      else { clearTimeout(guard); guard = setTimeout(normalise, 700); }   // transitionend can be skipped (tab hidden, same spot)
    }
    function normalise() {
      clearTimeout(guard);
      busy = false;
      track.classList.remove('is-anim');
      fold();
    }
    track.addEventListener('transitionend', function (e) { if (e.target === track && e.propertyName === 'transform') normalise(); });

    /* ── autoplay driven by the active dot's fill animation (pauses with it) ── */
    function playing() { return !userPaused && !held.boot && !held.hover && !held.focus && !held.hidden && !held.offscreen && !held.drag && !held.sheet && !held.touch; }
    function syncState() {
      root.classList.toggle('is-paused', userPaused);
      root.classList.toggle('is-playing', !userPaused);
      root.classList.toggle('is-held', !userPaused && !playing());
      if (pauseBtn) pauseBtn.setAttribute('aria-label', userPaused ? pauseBtn.getAttribute('data-label-play') : pauseBtn.getAttribute('data-label-pause'));
    }
    function restartFill() { /* the fill lives on the active dot's ::after; switching aria-current restarts it */ }
    dots.forEach(function (d) {
      d.addEventListener('animationend', function () { if (d.getAttribute('aria-current') === 'true' && playing()) go(p + 1); });
    });

    /* ── controls ── */
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var target = parseInt(d.getAttribute('data-goto'), 10), cur = realIndex(p);
        if (target !== cur) go(p + (target - cur));
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('.shp__nav'), function (b) {
      b.addEventListener('click', function () { go(p + parseInt(b.getAttribute('data-dir'), 10)); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { userPaused = !userPaused; syncState(); if (!userPaused) restartFill(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(p + 1); e.preventDefault(); }       // RTL: left = next
      else if (e.key === 'ArrowRight') { go(p - 1); e.preventDefault(); }
    });

    /* ── «+» every campaign at a glance: a sheet portalled to <body> (no ancestor containment can trap a fixed
       layer), page pinned with the theme's own lock so nothing behind it scrolls, focus kept inside ── */
    var moreBtn = root.querySelector('.shp__more');
    var sheet = root.querySelector('.shp-all');
    if (moreBtn && sheet) {
      var panel = sheet.querySelector('.shp-all__panel'), closeBtn = sheet.querySelector('.shp-all__close'), lastFocus = null, closing = 0;
      var LOCK = 'sds-scroll-locked';
      var lock = function () {
        var r = document.documentElement; if (r.classList.contains(LOCK)) return;
        var off = window.scrollY || window.pageYOffset || 0;
        r.setAttribute('data-scroll-lock-offset', String(off)); r.classList.add(LOCK); document.body.style.top = '-' + off + 'px';
      };
      var unlock = function () {
        var r = document.documentElement; if (!r.classList.contains(LOCK)) return;
        var off = Number(r.getAttribute('data-scroll-lock-offset')) || 0;
        r.classList.remove(LOCK); r.removeAttribute('data-scroll-lock-offset'); document.body.style.top = ''; window.scrollTo(0, off);
      };
      var focusables = function () { return Array.prototype.slice.call(sheet.querySelectorAll('a[href], button:not([disabled])')); };
      var onKey = function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus({ preventScroll: true }); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus({ preventScroll: true }); }
      };
      // INP (2026-10-16): focus moves after the frame that shows the change has
      // painted. focus() inside the tap forced a style pass over the pinned page
      // that the tap then waited for; the Tab handler covers the one frame between.
      var canPost = !!(window.scheduler && typeof window.scheduler.postTask === 'function');
      var afterPaint = function (fn) { requestAnimationFrame(function () { if (canPost) window.scheduler.postTask(fn, { priority: 'user-visible' }).catch(function () {}); else setTimeout(fn, 0); }); };
      var openSheet = function () {
        if (sheet.parentNode !== document.body) document.body.appendChild(sheet);
        clearTimeout(closing);
        lastFocus = document.activeElement;
        sheet.hidden = false;
        held.sheet = true; syncState(); lock();
        requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-open'); }); });
        moreBtn.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', onKey);
        afterPaint(function () { if (moreBtn.getAttribute('aria-expanded') === 'true') closeBtn.focus({ preventScroll: true }); });   // iOS: a plain focus() scrolls the pinned page to the top
      };
      var closeSheet = function () {
        if (sheet.hidden) return;
        sheet.classList.remove('is-open');
        moreBtn.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', onKey);
        unlock();
        held.sheet = false; syncState();
        closing = setTimeout(function () { sheet.hidden = true; }, reduce ? 0 : 300);
        var back = lastFocus;
        afterPaint(function () { if (back && back.focus && moreBtn.getAttribute('aria-expanded') !== 'true') back.focus({ preventScroll: true }); });
      };
      moreBtn.addEventListener('click', openSheet);
      closeBtn.addEventListener('click', closeSheet);
      sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
      // a tap on a campaign navigates; unpin first so the next page (and Back) restore normally
      sheet.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a[href]')) unlock(); });
    }

    /* holds: hover (fine pointers), keyboard focus, hidden tab, off-screen */
    if (window.matchMedia('(hover: hover)').matches) {
      viewport.addEventListener('mouseenter', function () { held.hover = true; syncState(); });
      viewport.addEventListener('mouseleave', function () { held.hover = false; syncState(); });
    }
    root.addEventListener('focusin', function (e) { if (e.target.matches(':focus-visible')) { held.focus = true; syncState(); } });
    root.addEventListener('focusout', function () { held.focus = false; syncState(); });
    document.addEventListener('visibilitychange', function () { held.hidden = document.hidden; syncState(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { held.offscreen = !es[0].isIntersecting; syncState(); }, { threshold: 0.2 }).observe(root);
    }

    /* ── drag / swipe: the track follows the finger; vertical scroll stays native (touch-action: pan-y) ── */
    var sx = 0, sy = 0, st = 0, dx = 0, dragging = false, decided = false, moved = false, pid = null;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      settle();                                             // grab it where it is — no jump to the end of the move
      held.touch = true; syncState();                       // autoplay never moves a card out from under a finger
      sx = e.clientX; sy = e.clientY; st = performance.now(); dx = 0; dragging = true; decided = false; moved = false; pid = e.pointerId;
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) return;
      var mx = e.clientX - sx, my = e.clientY - sy;
      if (!decided) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        decided = true;
        if (Math.abs(my) > Math.abs(mx)) { dragging = false; return; }   // a vertical scroll — let it go
        moved = true; held.drag = true; syncState(); markReady();
        try { viewport.setPointerCapture(pid); } catch (err) {}
        track.classList.remove('is-anim');
      }
      dx = mx;
      track.style.transform = 'translate3d(' + (x + dx) + 'px,0,0)';   // x stays the slot's offset; dx is the finger
    });
    function release() { if (held.touch) { held.touch = false; syncState(); } }
    function end(e) {
      if (e && e.pointerId !== pid) return;
      release();
      if (!dragging) return;
      dragging = false;
      if (!moved) return;
      held.drag = false; syncState();
      var w = all[p].offsetWidth, v = Math.abs(dx) / Math.max(1, performance.now() - st);
      var target = nearest(x + dx);                         // a long drag can travel more than one card
      if (target === p && (Math.abs(dx) > w * 0.18 || (v > 0.45 && Math.abs(dx) > 24))) target = p + (dx > 0 ? 1 : -1);   // finger to the right reveals the next (left) card
      if (target !== p) go(target);
      else { setX(x + dx); place(p, true); busy = !reduce; clearTimeout(guard); guard = setTimeout(normalise, 700); }
    }
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    // only the viewport's own capture ending counts — a touch is implicitly captured by the card it lands on, and handing
    // that capture to the viewport fires (and bubbles) a lostpointercapture from the card that is NOT a release
    viewport.addEventListener('lostpointercapture', function (e) { if (dragging && e.target === viewport) end(e); });
    // iOS: once the gesture is a horizontal drag, keep the page from also scrolling under it
    viewport.addEventListener('touchmove', function (e) { if (dragging && moved && e.cancelable) e.preventDefault(); }, { passive: false });
    // a drag is not a tap; a tap on a peeking card brings it to the centre instead of navigating
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; return; }
      var slide = e.target.closest('.shp__slide');
      if (slide && all.indexOf(slide) !== p) { e.preventDefault(); go(all.indexOf(slide)); }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* keep centred across resizes / rotations */
    var rz = 0;
    window.addEventListener('resize', function () { cancelAnimationFrame(rz); rz = requestAnimationFrame(function () { place(p, false); }); });

    place(p, false);
    setActive();
    syncState();
    bootDone();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.shp'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.shp'); if (r) init(r); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest && e.target.closest('.shp__slide'); var root = s && s.closest('.shp');
    if (root && root.__shp) { /* editor: no-op beyond keeping it visible */ }
  });
})();
